<template>
  <div class="m-slider" :class="{ 'm-slider--full': overflow }">
    <div ref="swiper" class="m-slider__swiper swiper">
      <div class="swiper-wrapper">
        <slot></slot>
      </div>
      <div ref="pagination" class="m-slider__pagination"></div>
    </div>
    <button type="button" ref="navPrev" class="m-slider__nav-left" :aria-label="$t('slider.previous')">
      <svg class="m-slider__nav-icon" aria-hidden="true">
        <use :xlink:href="$root.spritePath + '#slider-nav-arrow'"/>
      </svg>
    </button>
    <button type="button" ref="navNext" class="m-slider__nav-right" :aria-label="$t('slider.next')">
      <svg class="m-slider__nav-icon" aria-hidden="true">
        <use :xlink:href="$root.spritePath + '#slider-nav-arrow'"/>
      </svg>
    </button>
  </div>
</template>

<script>
import "swiper/css";
import Swiper, { Navigation, Pagination } from 'swiper'

export default {
  props: {
    slidesPerView: {
      type: Number,
      default: 3,
    },
    slidesPerViewMd: {
      type: Number,
      default: null,
    },
    autoHeight: {
      type: Boolean,
      default: false,
    },
    overflow: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    swiper: null,
  }),

  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      modules: [Navigation, Pagination],
      slidesPerView: 1.10,
      spaceBetween: this.getSpaceBetween(),
      watchOverflow: true,
      centeredSlides: this.overflow,
      autoHeight: this.autoHeight,
      pagination: {
        type: "bullets",
        el: this.$refs.pagination,
        clickable: true,
      },
      navigation: {
        nextEl: this.$refs.navNext,
        prevEl: this.$refs.navPrev,
      },
      breakpoints: {
        640: {
          slidesPerView: this.slidesPerView === 1 ? 1 : 2,
        },
        768: {
          slidesPerView: this.slidesPerViewMd || (this.slidesPerView === 1 ? 1 : 2),
        },
        1200: {
          slidesPerView: this.slidesPerView,
        },
      },
      on: {
        resize: (swiper) => {
          swiper.params.spaceBetween = this.getSpaceBetween();
        },
      },
    });
  },

  methods: {
    getSpaceBetween() {
      return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--layout-gap').replace("px", ""));
    },
  },
}
</script>
